import request from '@/axios';

/** 插件策略分页查询接口 */
export const getTacticsList = (params) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/page',
    method: 'get',
    params
  })
}

/** 获取插件列表的接口 */
export const getPluginsList = (params) => {
  return request({
    url: '/lebo-addition/web/appPlugin/list',
    method: 'get',
    params
  })
}

/** 新增插件策略的接口 */
export const addPluginsTactics = (data) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/save',
    method: 'post',
    data
  })
}

/** 编辑插件策略的接口 */
export const editPluginsTactics = (data) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/update',
    method: 'post',
    data
  })
}

/** 上线插件策略的接口 */
export const onlinePluginsTactics = (id) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/putOn',
    method: 'get',
    params: {
      id
    }
  })
}

/** 下线插件策略的接口 */
export const offlinePluginsTactics = (id) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/takeOff',
    method: 'get',
    params: {
      id
    }
  })
}

/** 禁用插件策略的接口 */
export const disablePluginsTactics = (id) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/disable',
    method: 'get',
    params: {
      id
    }
  })
}

/** 删除插件策略的接口 */
export const deletePluginsTactics = (id) => {
  return request({
    url: '/lebo-addition/web/appPluginCondition/delById',
    method: 'get',
    params: {
      id
    }
  })
}